function required(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(
      `Missing required environment variable ${name}. Add it to .env and restart the dev server.`,
    );
  }
  return value;
}

export const env = {
  supabaseUrl: required("VITE_SUPABASE_URL", import.meta.env.VITE_SUPABASE_URL),
  supabaseAnonKey: required(
    "VITE_SUPABASE_PUBLISHABLE_KEY",
    import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
  ),
  // Optional — falls back to empty string so apps without push configured still build.
  // The push subscription hook treats missing keys as "push unsupported".
  vapidPublicKey: import.meta.env.VITE_VAPID_PUBLIC_KEY ?? "",
} as const;

declare global {
  // Injected by Vite at build time (see vite.config.ts).
  const __APP_VERSION__: string;
  const __BUILD_DATE__: string;
}

export const appMeta = {
  version: typeof __APP_VERSION__ !== "undefined" ? __APP_VERSION__ : "dev",
  buildDate: typeof __BUILD_DATE__ !== "undefined" ? __BUILD_DATE__ : "dev",
} as const;
